/**
 * Model reprezentujący tag (etykietę) przypisywany do użytkowników w systemie.
 * Służy do segmentacji bazy klientów i umożliwia masową komunikację (np. wysyłanie
 * powiadomień do określonej grupy docelowej).
 */
export class UserTag {

  /** Kod systemowy tagu.
   */
  public code: string;

  /** Wartość wyświetlana (Label) w interfejsie użytkownika.
   */
  public value: string;

  /** Globalnie unikalny identyfikator tagu w bazie danych. */
  public uuid: string;

  /** Licznik użytkowników przypisanych do tego tagu.
   */
  public userCounter: number;

}
